// Vite Entry Point for Theme JavaScript

// Import CSS
import './theme.css';

// Import JavaScript modules
import { ComponentLoader } from '../scripts/utils/component-loader.js';
import { domReady } from '../scripts/utils/dom-ready.js';
import { initParallax } from '../scripts/utils/parallax.js';
import { LoaderPage } from '../scripts/components/loader-page.js';
import { LinkHoverColor } from '../scripts/components/link-hover-color.js';
import { initButtonPulse } from '../scripts/components/button-pulse.js';
import { SmoothScroll } from '../scripts/components/smooth-scroll.js';
import { logConsoleCredit } from '../scripts/utils/console-credit.js';
import { setupInvokersPolyfill } from '../scripts/utils/invokers-polyfill.js';

setupInvokersPolyfill();

// DOM 非依存のため即時実行 (domReady 待ち不要、LCP/FCP に影響しない)
logConsoleCredit();

// HMR Support
if (import.meta.hot) {
  import.meta.hot.accept();
}

// Initialize theme components
domReady(() => {
  // TOP ローダー: 該当要素がある時のみ Three.js + GSAP + GLTFLoader を含む
  // 専用 chunk を動的読み込み。他ページの theme.js には bundle されない。
  if (document.querySelector('[data-component="loader-index"]')) {
    import('../scripts/components/loader-index.js').then(({ LoaderIndex }) => {
      new LoaderIndex();
    });
  }

  // ページ遷移時Loading画面の初期化（SVG + 画像）
  new LoaderPage();

  // パララックス効果の初期化
  initParallax();

  // リンクホバーカラー変更の初期化
  new LinkHoverColor();

  // .u-btn の icon pulse (#650) を body delegation で全 button に適用
  initButtonPulse();

  // スムーススクロールの初期化
  new SmoothScroll();

  // 自動コンポーネント初期化システム開始
  const componentLoader = new ComponentLoader();

  // 開発環境でのグローバル参照（デバッグ用）
  if (process.env.NODE_ENV === 'development') {
    window.componentLoader = componentLoader;
  }

  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.log(
      '🎯 Rakuda Theme initialized with Vite + Component Auto-loader + Slack notifications',
    );
  }
});
